import { connect } from "react-redux";
import TableComponent from "../../../Components/RecordingsManagement/TableComponent/TableComponent";

const mapStateToProps = (state) => ({
  callFlows: state.reducer.CALL_FLOWS,
  supervisedAgentDetails: state.reducer.supervisedAgentDetails,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableComponent);
